"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.catalogCarLoader = void 0;
var toolkit_1 = require("@reduxjs/toolkit");
var toolkit_2 = require("@reduxjs/toolkit");
var initialState = {
    catalogCar: null,
    stateLoad: {
        isLoading: false,
        error: false,
    },
};
var catalogCarLoader = (0, toolkit_2.createAsyncThunk)('catalogCar/fetchCatalogCar', function (params) { return __awaiter(void 0, void 0, void 0, function () {
    var url, response, result, carData, error_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!params) {
                    throw new Error('Model ID is required');
                }
                _a.label = 1;
            case 1:
                _a.trys.push([1, 4, , 5]);
                url = "".concat(process.env.REACT_APP_BASE_URL, "/car_catalogs/").concat(params);
                console.log('Making API request to:', url);
                return [4 /*yield*/, fetch(url, {
                        method: 'GET',
                        headers: {
                            'Content-Type': 'application/json',
                        },
                    })];
            case 2:
                response = _a.sent();
                if (!response.ok) {
                    throw new Error("HTTP error! status: ".concat(response.status));
                }
                return [4 /*yield*/, response.json()];
            case 3:
                result = _a.sent();
                console.log('API Response:', result);
                if (!result) {
                    throw new Error('No data received from API');
                }
                carData = Array.isArray(result) ? result[0] : result;
                if (!carData) {
                    throw new Error('No car data found');
                }
                // Ensure required fields exist
                if (!carData.brand || !carData.model) {
                    throw new Error('Invalid car data received');
                }
                // Initialize empty arrays if they don't exist
                return [2 /*return*/, __assign(__assign({}, carData), { car_catalog_configurations: carData.car_catalog_configurations || [], car_catalog_images: carData.car_catalog_images || [], car_catalog_engines: carData.car_catalog_engines || [], car_colors: carData.car_colors || [] })];
            case 4:
                error_1 = _a.sent();
                console.error('Failed to load car catalog:', error_1);
                throw error_1;
            case 5: return [2 /*return*/];
        }
    });
}); });
exports.catalogCarLoader = catalogCarLoader;
var catalogCarSlice = (0, toolkit_1.createSlice)({
    name: 'catalogCar',
    initialState: initialState,
    reducers: {},
    extraReducers: function (builder) {
        builder
            .addCase(catalogCarLoader.fulfilled, function (state, action) {
            state.stateLoad.isLoading = false;
            state.stateLoad.error = false;
            state.catalogCar = action.payload;
        })
            .addCase(catalogCarLoader.pending, function (state) {
            state.stateLoad.error = false;
            state.stateLoad.isLoading = true;
            state.catalogCar = null; // Clear previous data while loading
        })
            .addCase(catalogCarLoader.rejected, function (state, action) {
            state.stateLoad.error = true;
            state.stateLoad.isLoading = false;
            state.catalogCar = null;
            console.error('Error in catalogCarSlice:', action.error);
        });
    },
});
exports.default = catalogCarSlice.reducer;
